<template>
  <div>
    <transition name="PointerLock">
      <div class="PointerLock" v-if="showLock" @click="return3DWorld">
        <div class="PointerLock__bg" />
        <div class="PointerLock__text Btn">
          {{ trans('enter') }}
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
import * as BABYLON from 'babylonjs'

export default {
  name: 'PointerLock',
  beforeDestroy() {
    document.removeEventListener('pointerlockchange', this.onLockChange, false)
    document.exitPointerLock()
    this.$scene.onPointerObservable.remove(this.$click)
  },
  translations: {
    fr: { enter: 'Retour au jeu' },
    en: { enter: 'Back to game' },
  },
  data: () => ({
    pointerLock: true,
  }),
  computed: {
    showLock() {
      if(this.slugIsIn(['pan', 'secret']))
        return false

      if(this.is2DWorld || this.pointerLock)
        return false

      return true
    }
  },
  watch: {
    is2DWorld() {
      if(this.is2DWorld)
        document.exitPointerLock()
    }
  },
  mounted() {   
    this.$canvas = this.$parent.$canvas
    this.$scene = this.$parent.$scene
    this.$camera = this.$parent.$camera

    this.$parent.$engine.isPointerLock = true

    document.addEventListener('pointerlockchange', this.onLockChange, false)

    this.$click = this.$scene.onPointerObservable.add(evt => {
      if(this.slugIsIn(['pan', 'secret'])) return
      this.$canvas.requestPointerLock()
    }, BABYLON.PointerEventTypes.POINTERDOWN)
  },
  methods: {
    onLockChange() {
      this.pointerLock = document.pointerLockElement === this.$canvas
      this.$store.commit('app/IS_LOCKED', this.pointerLock)
      this.pointerLock
      ? this.$camera.attachControl(this.$canvas)
      : this.$camera.detachControl(this.$canvas)
    }
  }
}
</script>

<style lang="stylus">
@import '~@/config/Settings'

.PointerLock
  position fixed
  width 100vw
  height 100vh
  top 0px
  left 0px
  background-color rgba(black, .8)
  transition opacity 1s
  // display none

  z-index 20000

  &-enter
  &-leave-active
    opacity 0

  &__bg
    position absolute
    top 50%
    left 50%
    transform translate(-50%, -50%)
    width 800px
    height 800px
    background-image url('~@/commons/img/smoke.png')
    background-size contain
    background-repeat no-repeat
    background-position center center

  &__text
    position absolute
    top 50%
    left 50%
    transform translate(-50%, -50%)
    text-align center
    width 200px
    cursor pointer
</style>



// WEBPACK FOOTER //
// src/components/world/elements/PointerLock.vue